var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAiBigIcon = function SvgAiBigIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-big-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 16,
    fill: "#CADFF8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai-big-icon_svg__b)",
    d: "M0 0h58v58H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.233 20.733a1.233 1.233 0 0 1-1.566-.8 7.464 7.464 0 0 0-1.8-2.916C31.6 14.75 28.2 14.25 25.433 15.55c-.1-.033-.216-.067-.316-.1-1.15-.3-2.284-.417-3.4-.35 3.883-3.733 10.083-3.683 13.916.15a9.53 9.53 0 0 1 2.4 3.917 1.233 1.233 0 0 1-.8 1.566ZM35.467 44a9.895 9.895 0 0 1-6.867 2.767 10.069 10.069 0 0 1-7.05-2.917 9.68 9.68 0 0 1-2.4-3.917 1.233 1.233 0 0 1 .8-1.566 1.233 1.233 0 0 1 1.567.8 7.316 7.316 0 0 0 1.8 2.916 7.467 7.467 0 0 0 5.283 2.184c1.1 0 2.167-.25 3.15-.717.1.033.2.067.317.1 1.133.3 2.283.417 3.4.35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.483 28.517a10.1 10.1 0 0 1-2.166 4.033c-.25.267-.584.417-.934.417-.3 0-.583-.1-.833-.317a1.244 1.244 0 0 1-.1-1.767c.767-.85 1.317-1.9 1.633-3.033a7.477 7.477 0 0 0-2.966-8.067 10.474 10.474 0 0 0-1.467-3.4c2.5.7 4.567 2.334 5.85 4.567a9.838 9.838 0 0 1 .983 7.567ZM19.5 42.717c-5.183-1.5-8.233-6.9-6.817-12.134.4-1.5 1.134-2.85 2.184-4.016a1.245 1.245 0 0 1 1.766-.1c.517.466.55 1.25.1 1.766a7.435 7.435 0 0 0-1.65 3.017c-.816 3.1.45 6.3 2.967 8.05a10.679 10.679 0 0 0 1.45 3.417ZM43.5 38.183c-1.333 2.3-3.483 3.934-6.067 4.634-.85.216-1.7.333-2.566.333-.667 0-1.35-.067-2.017-.217a1.225 1.225 0 0 1-.967-1.466c.134-.684.8-1.117 1.467-.967 1.15.233 2.317.2 3.45-.1a7.438 7.438 0 0 0 4.533-3.483A7.245 7.245 0 0 0 42.3 33.8a10.22 10.22 0 0 0 2.233-2.983 9.817 9.817 0 0 1-1.033 7.366Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 17.633a1.225 1.225 0 0 1-1.467.967 7.54 7.54 0 0 0-3.45.1 7.472 7.472 0 0 0-4.533 3.467 7.247 7.247 0 0 0-.967 3.116c-.9.85-1.666 1.85-2.25 3a9.901 9.901 0 0 1 1.05-7.366 9.889 9.889 0 0 1 6.067-4.634 9.69 9.69 0 0 1 4.583-.116c.684.133 1.117.8.967 1.466Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m35.183 34.667-5-11.25c-.2-.45-.65-.75-1.15-.75h-.666c-.5 0-.95.283-1.15.75l-5 11.25c-.284.633 0 1.366.633 1.65.633.283 1.367 0 1.65-.634l1.117-2.5h6.15l1.116 2.5a1.245 1.245 0 0 0 1.65.634 1.245 1.245 0 0 0 .634-1.65h.016Zm-8.433-3.984 1.967-4.416 1.966 4.416H26.75Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-big-icon_svg__b",
    x1: 0,
    y1: 0,
    x2: 58,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3432C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B632C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-big-icon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 16,
    fill: "#fff"
  })))));
};
export default SvgAiBigIcon;